// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["static_library_getDynamicConfig_ts"], () => (__webpack_require__(905)))
var __webpack_exports__ = __webpack_require__.O(undefined, ["static_library_getDynamicConfig_ts"], () => (__webpack_require__(502)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
